import { render, staticRenderFns } from "./OwnerEmailNotificationForm.vue?vue&type=template&id=61e30fae&"
import script from "./OwnerEmailNotificationForm.vue?vue&type=script&lang=js&"
export * from "./OwnerEmailNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports